export default __webpack_public_path__ + "static/cabin-sunset-60cecb2461962cd3d1ee1ba7b6cf3188.jpg";